// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-polaris-unstyled] {\n    color: inherit;\n    text-decoration: none;\n}\n\n*[data-polaris-unstyled]:hover {\n    color: inherit;\n}\n\n*[data-polaris-unstyled]:focus {\n    color: inherit;\n}", ""]);
// Exports
module.exports = exports;
